import { TRoadblockConfiguration } from "./roadblockTypesAndCodecs";
import { Quote } from "./configurations/Quote";
import { Contracts } from "./configurations/Contracts";
import { ClientVerification } from "./configurations/ClientVerification";
import { ChaseInstruction } from "./configurations/ChaseInstruction";
import { TitleChecks } from "./configurations/TitleChecks";
import { ContractReady } from "./configurations/ContractReady";
import { ExchangeReady } from "./configurations/ExchangeReady";
import { PreCompletionReady } from "./configurations/PreCompletionReady";
import { CompletionReady } from "./configurations/CompletionReady";
import { PostCompletion } from "./configurations/PostCompletion";

export type TRoadblockConfigurationSet = Array<TRoadblockConfiguration>;

export const slRoadblockConfigs: TRoadblockConfigurationSet = [
    Quote,
    Contracts,
    ClientVerification,
    ChaseInstruction,
    TitleChecks,
    ContractReady,
    ExchangeReady,
    PreCompletionReady,
    CompletionReady,
    PostCompletion,
];
